import React, { useState } from 'react';
import { AuditLogFilters } from '../types';
import AuditLogList from '../components/audit/AuditLogList';
import ScrollHeader from '../components/common/ScrollHeader';
import { useAppSelector } from '../hooks';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

const AuditLogs: React.FC = () => {
  const { user: currentUser } = useAppSelector((state) => state.auth);
  const [filters, setFilters] = useState<AuditLogFilters>({
    limit: 100,
    skip: 0,
    org_id: currentUser?.role === 'org_admin' ? currentUser.organization_id : undefined
  });

  // Only super admins and org admins can access audit logs
  if (!currentUser || (currentUser.role !== 'super_admin' && currentUser.role !== 'org_admin')) {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-96px)]">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-500/10">
            <ShieldExclamationIcon className="h-6 w-6 text-red-500" />
          </div>
          <h3 className="mt-4 text-lg font-semibold text-gray-900 dark:text-white">
            Access Denied
          </h3>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            You don't have permission to view audit logs.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div>
        <ScrollHeader title="Audit Logs" />
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Track and monitor system activities and changes
        </p>
      </div>

      <div className="rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border overflow-hidden">
        <AuditLogList 
          filters={filters}
          onFilterChange={setFilters}
        />
      </div>
    </div>
  );
};

export default AuditLogs;